export const contactMessagesData = [
  {
    checkbox: true,
    star: true,
    name: "Darlee Robertson",
    avatar: "assets/img/profiles/avatar-19.jpg",
    position: "Facility Manager",
    phone: "1234567890",
    email: "robertson@example.com",
    message: "Duis aute irure dolor in reprehenderit",
    created: "25 Sep 2023, 12:12 pm",
    key: "1",
  },
  {
    checkbox: true,
    star: true,
    name: "Sharon Roy",
    avatar: "assets/img/profiles/avatar-20.jpg",
    position: "Installer",
    phone: "+1 989757485",
    email: "sharon@example.com",
    message: "Excepteur sint occaecat cupidatat",
    created: "27 Sep 2023, 07:40 am",
    key: "2",
  },
  {
    checkbox: true,
    star: true,
    name: "Vaughan",
    avatar: "assets/img/profiles/avatar-21.jpg",
    position: "Senior Manager",
    phone: "+1 546555455",
    email: "vaughan12@example.com",
    message: "Lorem ipsum dolor sit consectetur",
    created: "29 Sep 2023, 08:20 am",
    key: "3",
  },
  {
    checkbox: true,
    star: true,
    name: "Jessica",
    avatar: "assets/img/profiles/avatar-23.jpg",
    position: "Test Engineer",
    phone: "+1 454478787",
    email: "jessica13@example.com",
    message: "Nemo enim ipsam voluptatem quia",
    created: "25 Sep 2023, 12:12 pm",
    key: "4",
  },
  {
    checkbox: true,
    star: true,
    name: "Carol Thomas",
    avatar: "assets/img/profiles/avatar-16.jpg",
    position: "UI / UX Designer",
    phone: "+1 124547845",
    email: "caroltho3@example.com",
    message: "Sed ut perspiciatis unde omnis iste",
    created: "02 Oct 2023, 10:10 am",
    key: "5",
  },
  {
    checkbox: true,
    star: true,
    name: "Dawn Mercha",
    avatar: "assets/img/profiles/avatar-22.jpg",
    position: "Technician",
    phone: "+1 478845447",
    email: "dawnmercha@example.com",
    message: "Ut enim ad minim veniam, quis",
    created: "17 Oct 2023, 04:25 pm",
    key: "6",
  },
  {
    checkbox: true,
    star: true,
    name: "Rachel Hampton",
    avatar: "assets/img/profiles/avatar-24.jpg",
    position: "Software Developer",
    phone: "+1 215544845",
    email: "rachel@example.com",
    message: "Duis aute irure dolor in reprehenderit",
    created: "28 Oct 2023, 07:16 am",
    key: "7",
  },
  {
    checkbox: true,
    star: true,
    name: "Jonelle Curtiss",
    avatar: "assets/img/profiles/avatar-25.jpg",
    position: "Supervisor",
    phone: "+1 121145471",
    email: "jonelle@example.com",
    message: "Ut enim ad minim veniam, quis",
    created: "08 Nov 2023, 06:10 am",
    key: "8",
  },
  {
    checkbox: true,
    star: true,
    name: "Jonathan",
    avatar: "assets/img/profiles/avatar-26.jpg",
    position: "Team Lead Dev",
    phone: "+1 321454789",
    email: "jonathan@example.com",
    message: "Excepteur sint occaecat cupidatat",
    created: "15 Nov 2023, 11:50 am",
    key: "9",
  },
  {
    checkbox: true,
    star: true,
    name: "Brook",
    avatar: "assets/img/profiles/avatar-01.jpg",
    position: "Team Lead Dev",
    phone: "+1 278907145",
    email: "brook@example.com",
    message: "Ut enim ad minim veniam, quis",
    created: "25 Nov 2023, 06:34 pm",
    key: "10",
  },
];
